import script from "./OfCorrections.vue?vue&type=script&setup=true&lang=js"
export * from "./OfCorrections.vue?vue&type=script&setup=true&lang=js"

import "./OfCorrections.vue?vue&type=style&index=0&id=34b25d0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b25d0f"]])

export default __exports__